import { atomWithStorage } from "jotai/utils";

export const selectedDeveloperIndexAtom = atomWithStorage<{ developerId: string; name: string }>("developerIndex", {
  developerId: "",
  name: "",
});

export default selectedDeveloperIndexAtom;
